module.exports = __webpack_public_path__ + "static/media/toggle-off.e500252a.svg";